import { render, staticRenderFns } from "./StockForm.vue?vue&type=template&id=abe81954&scoped=true"
import script from "./StockForm.vue?vue&type=script&lang=js"
export * from "./StockForm.vue?vue&type=script&lang=js"
import style0 from "./StockForm.vue?vue&type=style&index=0&id=abe81954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abe81954",
  null
  
)

export default component.exports